import { IBackgroundJobStatistics } from '../types/IBackgroundJobStatistics';
import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { Request } from './Request';

export interface IGetBackgroundJobStatisticsResult extends IGetItemsResult, IBackgroundJobStatistics {}

export class GetBackgroundJobStatisticsRequest extends Request<IGetItemsParams, IGetBackgroundJobStatisticsResult> {
  constructor(params: IGetItemsParams) {
    super('getBackgroundJobStatistics', params);
  }
}
